import React from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';

import { Alert } from 'components/Alert';
import { Tree } from 'components/Tree';

import { convertReplenishmentPathToTree, ViewReplenishmentPathsTreeProps } from './utils';

export function ViewReplenishmentPathsTree({
  searchQuery,
  replenishmentPathTree,
  requirementLocationId,
  defaultExpandAll = false,
  showExpandCollapseButton = true,
  onViewAll,
  truncate = false,
  getCustomTitle,
  viewAllOverride,
}: ViewReplenishmentPathsTreeProps) {
  const treeData = convertReplenishmentPathToTree(replenishmentPathTree, {
    replenishmentPathTree,
    requirementLocationId,
    truncate,
    onViewAll,
    getCustomTitle,
    viewAllOverride,
  });

  const isSingleLocation =
    replenishmentPathTree.length === 1 &&
    (!replenishmentPathTree[0].children || replenishmentPathTree[0].children.length === 0);

  const treeContent = (
    <>
      {isSingleLocation && (
        <Alert
          message="This location purchases for itself and doesn't replenish any other locations."
          icon={<InfoCircleOutlined />}
          type="info"
          banner
          className={css`
            margin-bottom: 16px;
          `}
        />
      )}
      <Tree
        searchQuery={searchQuery}
        defaultExpandAll={defaultExpandAll}
        className={css`
          .ant-tree-treenode-disabled {
            display: none;
          }
          .ant-tree-node-content-wrapper::before {
            cursor: text !important;
          }
          .ant-tree-node-content-wrapper {
            cursor: text !important;
          }
        `}
        treeData={treeData}
        setTreeData={() => {}}
        showExpandCollapseButton={showExpandCollapseButton}
        draggable={false}
      />
    </>
  );

  return treeContent;
}
